import React, {useState} from 'react';
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft, FaArrowRight, FaTrash} from "react-icons/fa";
import projectUtils from "../../../../utils/project-utils.js";
import AlertMessages from "../../../../components/messages/alert-message.js";
import myUserService from "../../../../services/web/my-user-service.js";
import {toast} from "react-toastify";
import InputSwitch from "../../../../components/input/input-switch.jsx";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {FaCircleCheck, FaCircleExclamation} from "react-icons/fa6";

const MySwal = withReactContent(Swal);

const MyUserTwoFactor = ({user, setTarget, refetch}) => {
    const [checked, setChecked] = useState(user?.twoFactorEnabled ?? false);

    const handleTwoFactor = (checked, showSwal = true) => {
        setChecked(user?.twoFactorEnabled ?? false);
        const keyWord = "Desativar";

        if (user?.twoFactorEnabled && showSwal) {
            MySwal.fire({
                title: "Atenção",
                showCancelButton: true,
                html: `
                    Esta operação não pode ser desfeita!<br> 
                    Para desativar, digite <span class="font-bold">${keyWord}</span> abaixo:
                `,
                confirmButtonText: "Desativar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: '#063A6C',
                cancelButtonColor: '#4a5565',
                input: "text",
                reverseButtons: true,
                preConfirm(inputValue) {
                    if (inputValue.trim() !== keyWord) {
                        Swal.showValidationMessage(`Digite corretamente a palavra-chave`);
                    }
                }
            }).then(({isConfirmed}) => {
                if (isConfirmed) {
                    handleTwoFactor(checked, false);
                }
            });

            return;
        }

        const formData = new FormData();
        formData.append("two_factor_enabled", !user.twoFactorEnabled);

        myUserService.twoFactorEnabled(formData)
            .then(() => {
                toast.success("Salvo com sucesso");
                setChecked(!user.twoFactorEnabled);
                refetch();
            })
            .catch(error => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            });
    }

    const handleTotp = () => {
        if (!user?.twoFactorEnabled) return;

        if (user?.twoFactorTOTP) {
            MySwal.fire({
                title: "Atenção",
                showCancelButton: true,
                html: `
                    Esta operação não pode ser desfeita!<br> 
                    Deseja remover o Google Authenticator?
                `,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                confirmButtonColor: '#063A6C',
                cancelButtonColor: '#4a5565',
                reverseButtons: true
            }).then(({isConfirmed}) => {
                if (isConfirmed) {
                    myUserService.totpRemove()
                        .then(() => {
                            toast.success("Salvo com sucesso");
                            refetch();
                        })
                        .catch(error => {
                            console.error(error);

                            const {message} = error.response.data;

                            let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                            projectUtils.swalErrorMessage("", errMessage, "Ok");
                        });
                }
            });

            return;
        }

        setTarget("totpConfig");
    }

    return (
        <Card>
            <Card.Body>
                <div className={"flex justify-between"}>
                    <h3 className="flex gap-2 items-center">
                        <FaArrowLeft className="cursor-pointer font-normal" onClick={() => setTarget("info")}/>
                        Autenticação de dois fatores
                    </h3>

                    <InputSwitch
                        id="twoFactor"
                        checked={checked}
                        onChange={handleTwoFactor}
                    />
                </div>

                <section className={!user?.twoFactorEnabled ? " opacity-25" : ""}>
                    <div className={"flex gap-2 h-[50px] px-[20px] items-center text-[14px]"}>
                        {
                            user?.email ? <FaCircleCheck color={"#008C27"} size={"20px"}/> : <FaCircleExclamation color={"#ff9900"} size={"20px"}/>
                        }
                        E-mail
                    </div>
                    <div className={"flex gap-2 h-[50px] px-[20px] items-center text-[14px]"}>
                        {
                            user?.mainDevice ? <FaCircleCheck color={"#008C27"} size={"20px"}/> : <FaCircleExclamation color={"#ff9900"} size={"20px"}/>
                        }
                        Sms
                    </div>
                    <div className={"flex justify-between h-[50px] px-[20px] items-center text-[14px]"}>
                        <div className={"flex gap-2"}>
                            {
                                user?.twoFactorTOTP ? <FaCircleCheck color={"#008C27"} size={"20px"}/> : <FaCircleExclamation color={"#ff9900"} size={"20px"}/>
                            }
                            Google Authenticator
                        </div>
                        <div className={"flex items-center gap-2 " + (user?.twoFactorEnabled ? "cursor-pointer" : "")} onClick={handleTotp}>
                            {user?.twoFactorTOTP ? "" : "Configurar"}
                            {user?.twoFactorTOTP ? <FaTrash /> : <FaArrowRight />}
                        </div>
                    </div>
                </section>
            </Card.Body>
        </Card>
    );
};

export default MyUserTwoFactor;